var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashGrayMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4871 17.9492L11.4871 12.9236",
    stroke: "#C2CFE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5129 17.9492L16.5129 12.9236",
    stroke: "#C2CFE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 8.16797H3.5C4.90446 8.16797 5.60669 8.16797 6.11114 8.50503C6.32952 8.65095 6.51702 8.83845 6.66294 9.05683C7 9.56128 7 10.2635 7 11.668V19.3346C7 21.2203 7 22.1631 7.58579 22.7488C8.17157 23.3346 9.11438 23.3346 11 23.3346H17C18.8856 23.3346 19.8284 23.3346 20.4142 22.7488C21 22.1631 21 21.2203 21 19.3346V11.668C21 10.2635 21 9.56128 21.3371 9.05683C21.483 8.83845 21.6705 8.65095 21.8889 8.50503C22.3933 8.16797 23.0955 8.16797 24.5 8.16797Z",
    stroke: "#C2CFE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8793 4.6541C11.0633 4.34878 11.4689 4.07899 12.0332 3.88657C12.5974 3.69414 13.2887 3.58984 13.9999 3.58984C14.7111 3.58984 15.4025 3.69414 15.9667 3.88657C16.5309 4.07899 16.9366 4.34878 17.1206 4.6541",
    stroke: "#C2CFE0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGrayMedium);
export default __webpack_public_path__ + "static/media/trash-gray-medium.1fce12b02ffa92590c71f1994db91f8a.svg";
export { ForwardRef as ReactComponent };